export default "__VITE_ASSET__3K4pdTXM__"